// Who the platform console is for (`RPM-064`, `CR-46`, `J-297`).
//
// THE ASSIGNMENT DECIDES, NEVER `user.role` (`D-1620`): the console is offered to an account whose
// current assignments include a `PLATFORM_OPERATOR` held at `PLATFORM` scope — the server's own
// `requirePermission({ platform: [...] }, { scopeKind: "PLATFORM" })`, asked with no building named
// (`grantsAtScope`). The server decides again on every request; this gates presentation only.
//
// THE LANDING PAGE. An account that reaches the console and holds nothing in any tenant has no other
// screen it may use, so signing in lands it on `/platform`; an account that holds both lands where
// every account does.
import { grantsAtScope, type HeldAssignment } from "@chartvn/schema/permissions";

export function reachesPlatformConsole(assignments: readonly HeldAssignment[]): boolean {
  return grantsAtScope(assignments, { platform: ["provision_tenant"] }, ["PLATFORM"]);
}

export function landsOnPlatformConsole(assignments: readonly HeldAssignment[]): boolean {
  return (
    reachesPlatformConsole(assignments) && assignments.every((a) => a.scopeKind === "PLATFORM")
  );
}
